"use client";

import { Button, Icon, VStack } from "@jace/ui";
import { useEffect } from "react";

export default function Page({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}): React.ReactElement {
	useEffect(() => {
		console.error("Page error:", error);
	}, [error]);

	return (
		<div className="flex h-full w-full items-center justify-center bg-surface p-lg">
			<VStack className="max-w-[480px] items-center gap-lg rounded-2xl bg-background-darkest p-2xl text-center">
				<div className="text-text-body">
					<Icon
						className="mb-lg text-text-body-muted"
						kind="warning"
						size="md"
					/>
					<h1 className="mb-md font-semibold text-2xl">Something went wrong</h1>
					<p className="mb-lg text-text-body-muted">
						We apologize for the inconvenience. Our team has been notified and
						is working to resolve the issue.
					</p>
					<p className="mb-md text-sm text-text-body-muted">
						If this issue persists, please contact{" "}
						<a
							className="text-text-link hover:text-text-link-hover"
							href="mailto:feedback@zetalabs.ai"
						>
							feedback@zetalabs.ai
						</a>
					</p>
				</div>
				<Button className="min-w-[120px]" intent="brand" onClick={reset}>
					Try Again
				</Button>
			</VStack>
		</div>
	);
}
